import Swiper from 'swiper/bundle';

export function initNewGallery(swiperClass){
    console.log('swiperINIT')
    let swiperContacts = new Swiper("." + swiperClass, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        //freeMode: true,
        //centeredSlides: false,
    });
}
export function initNewTagList(swiperClass){
    console.log('initNewTagList init')
    let swiperContacts = new Swiper("." + swiperClass, {
        spaceBetween: 12,
        slidesPerView: 'auto',
        freeMode: true,
        //centeredSlides: false,
    });
}

// ../swiper/swiper.js
export function initApproveUniversityList(swiperClass){
    console.log('initApproveUniversityList init')
    const swiperContacts = new Swiper("." + swiperClass, {
        freeMode: true,
        slidesPerView: 1.3,
        spaceBetween: 30,
        breakpoints: {
            480: {
                slidesPerView: 2.4,
                spaceBetween: 30
            },
            920: {
                slidesPerView: 3.4,
                spaceBetween: 30
            },
            1250: {
                slidesPerView: 4.4,
                spaceBetween: 30
            },
        }
    });

    return swiperContacts;
}
